import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-width-view',
  templateUrl: './width-view.component.html'
})
export class WidthViewComponent implements OnInit {

  innerWidth: number = 0;


  @HostListener("window:resize", ["$event"])
  onResize() {
    this.innerWidth = window.innerWidth;
  }

  ngOnInit(): void {
    this.onResize();
  }
}
